export default {
  'hero.tagline': 'Global Data Infrastructure',
  'hero.mainTitle': '讓數據回歸核心',
  'hero.subTitle': 'Data Returns to the Axis',
  'hero.description': '從底層存儲芯片到頂層系統架構，AX Axis 重塑數據生態，讓每一份數據在安全、高效、智能的「軸心」上流轉。',
  'hero.cta': '探索生態體系',
  'hero.brandIdentifier': 'AX AXIS INTERNATIONAL HOLDING LIMITED',

  'identity.label': 'Identity & Vision',
  'identity.companyName': '艾思國際控股有限公司',
  'identity.vision': '成為全球領先的私域數據生態構建者，讓每一份數據都能在安全、高效、智能的「軸心」上流轉。',
  'identity.description': '我們是一家專注於高性能存儲解決方案與網絡基建的領先供應商。我們致力於為企業及個人用戶提供從底層芯片到頂層架構的全鏈路數據支持。',
  'identity.feature1.title': '安全',
  'identity.feature1.desc': '端到端數據安全保障',
  'identity.feature2.title': '高效',
  'identity.feature2.desc': '企業級數據傳輸',
  'identity.feature3.title': '智能',
  'identity.feature3.desc': '本地化 AI 處理',
  'identity.cta': '了解品牌故事',

  'business.title': '核心業務',
  'business.subtitle': '三大引擎',
  'business.chipTrade.name': '存儲芯片國際貿易',
  'business.chipTrade.nameEn': 'Global Chip Trade',
  'business.chipTrade.desc': '我們專注於 NAND Flash 與 DRAM 顆粒的全球進出口業務。憑藉深厚的行業積累，AX Axis 與全球主要原廠及經銷體系建立了穩固的配額合作關係，確保在市場波動中為客戶提供穩定的現貨供應與極具競爭力的價格。',
  'business.chipTrade.spec': 'NAND / DRAM',
  'business.consumerBrand.name': '自營高性能存儲品牌',
  'business.consumerBrand.nameEn': 'Consumer Storage Brand',
  'business.consumerBrand.desc': 'AX Axis 致力於將硬核技術與極簡工業美學相結合。我們的產品線涵蓋高性能移動硬盤、高速 SD/TF 存儲卡及企業級 SSD 終端。每一件產品都代表了我們對效能的極致追求與對設計美學的堅持。',
  'business.consumerBrand.spec': 'SSD / SD / HDD',
  'business.aiNAS.name': 'AI NAS 智能系統',
  'business.aiNAS.nameEn': 'Axis OS',
  'business.aiNAS.desc': 'Axis OS 是我們自主研發的核心軟件生態。作為一款專為 AI 時代設計的智能存儲系統，它為企業及家庭提供「軍用級加密」的本地私有雲解決方案。通過零配置內網穿透與極致的用戶交互體驗，讓數據資產在絕對安全的前提下，實現跨地域的無縫協同。',
  'business.aiNAS.spec': 'Axis OS / AI Ready',

  'strategy.label': 'Strategic Positioning',
  'strategy.title': '戰略定位',
  'strategy.subtitle': '香港研發，全球生態 —— 構建穩固的商業架構，以香港為核心動力引擎',
  'strategy.hk.title': '扎根香港',
  'strategy.hk.subtitle': 'Rooted in Hong Kong',
  'strategy.hk.desc': '擁有專屬香港研發團隊，專注於 AX Axis 產品的研發。',
  'strategy.hk.points.0': 'Axis OS 自主研發',
  'strategy.hk.points.1': '知識產權保護',
  'strategy.hk.points.2': '國際品牌背書',
  'strategy.hk.tag': '香港研發中心',
  'strategy.cn.title': '背靠內地',
  'strategy.cn.subtitle': 'Powered by Mainland China',
  'strategy.cn.desc': '深度整合大灣區及內地領先的電子製造產業鏈，確保高效交付與成本控制。',
  'strategy.cn.points.0': '半導體封裝測試',
  'strategy.cn.points.1': '高效供應鏈整合',
  'strategy.cn.points.2': '大灣區製造優勢',
  'strategy.cn.tag': '製造供應鏈',
  'strategy.global.title': '面向全球',
  'strategy.global.subtitle': 'Global Market Focus',
  'strategy.global.desc': '以香港為支點，通過國際物流與多語言服務，將存儲解決方案輸出至全球市場。',
  'strategy.global.points.0': '國際物流體系',
  'strategy.global.points.1': '多語言技術支持',
  'strategy.global.points.2': '全球市場滲透',
  'strategy.global.tag': '全球市場拓展',

  'advantage.title': 'AX 的護城河',
  'advantage.subtitle': '自主 OS · 全鏈路研發 · 香港品牌 · 極致工業美學',
  'advantage.item1.title': '自主系統護城河',
  'advantage.item1.desc': '香港研發團隊打造的 Axis OS，確保系統層面的絕對自主權與全球領先的安全性。',
  'advantage.item2.title': '全鏈路研發能力',
  'advantage.item2.desc': '從底層顆粒到系統固件再到最終用戶界面，實現深度垂直整合。',
  'advantage.item3.title': '國際化品牌紅利',
  'advantage.item3.desc': '香港本土品牌的國際化形象更易獲得全球高端及政企用戶的信任。',
  'advantage.item4.title': '極致工業美學',
  'advantage.item4.desc': '通過特斯拉風格的視覺語言，吸引追求生活品質的高端受眾。',

  'roadmap.label': 'Roadmap',
  'roadmap.title': '發展路線圖',
  'roadmap.description': '2021 — 2026 關鍵里程碑，從香港出發，重塑全球數據新標準',
  'roadmap.milestone1.quarter': '2021',
  'roadmap.milestone1.title': '公司於香港正式成立',
  'roadmap.milestone1.desc': '在香港正式成立，定位為存儲芯片國際貿易商。',
  'roadmap.milestone2.quarter': '2022 - 2023',
  'roadmap.milestone2.title': '全球貿易啟動',
  'roadmap.milestone2.desc': '利用內地供應鏈優勢，啟動全球貿易計劃，滲透全球終端存儲市場。',
  'roadmap.milestone3.quarter': 'Q4 2025',
  'roadmap.milestone3.title': '終端存儲滲透',
  'roadmap.milestone3.desc': '加速 USB 閃存盤、移動硬盤等終端產品在全球市場的渠道鋪設。',
  'roadmap.milestone4.quarter': '2026+',
  'roadmap.milestone4.title': '加速 Axis OS 研發',
  'roadmap.milestone4.desc': '團隊加速 OS 研發，加速 NAS 產品迭代',
  'roadmap.bottomLine1': 'Axis，讓數據回歸核心',
  'roadmap.bottomLine2': 'DATA RETURNS TO THE AXIS',

  'careers.label': 'Join Us',
  'careers.title': '人才招聘',
  'careers.description': '我們正在尋找充滿熱情的人才，一起打造全球領先的數據基礎設施。加入我們，共同推動技術創新與產業變革。',
  'careers.position1.title': '軟件工程師',
  'careers.position1.desc': '參與 Axis OS 核心系統開發，打造下一代智能存儲平台。',
  'careers.position2.title': '硬件工程師',
  'careers.position2.desc': '負責存儲設備與終端產品的硬件設計、測試與優化。',
  'careers.position3.title': '國際業務拓展',
  'careers.position3.desc': '開拓全球市場渠道，建立國際合作夥伴關係。',
  'careers.ctaTitle': '有意加入我們的團隊？',
  'careers.ctaDesc': '請將您的履歷發送至以下郵箱，我們期待與您對話。',
};